import { useEffect } from "react";

// Ref-counted body scroll lock. Multiple components (the mobile menu drawer,
// the fullscreen map view, etc.) can ask for `body { overflow: hidden }` at
// the same time; we only release once the last one unmounts. A naive
// save/restore pattern races when two locks overlap and can strand the body
// at overflow:hidden, killing page scroll.
let lockCount = 0;

function acquire() {
  lockCount += 1;
  if (lockCount === 1) document.body.style.overflow = "hidden";
}

function release() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) document.body.style.overflow = "";
}

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    acquire();
    return release;
  }, [active]);
}
